import { NgModule } from '@angular/core';
import { Routes, RouterModule, provideRouter } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/app/customers', pathMatch: 'full' },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'app',
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
    {path: '**' , redirectTo: 'app/customers', pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class RootRoutingModule {}
